import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useFeatureFlags, useToggleFeatureFlag } from './hooks';
export function useFeatureFlagsMode({ onClose, search, enabled = true }) {
    const history = useHistory();
    const { data: allFlags = [], isPending } = useFeatureFlags(enabled);
    const toggleFlag = useToggleFeatureFlag();
    const flags = useMemo(() => {
        const normalizedSearch = search.trim().toLowerCase();
        if (!normalizedSearch)
            return allFlags;
        return allFlags.filter(flag => flag.name.toLowerCase().includes(normalizedSearch) ||
            flag.key.toLowerCase().includes(normalizedSearch) ||
            (flag.description ?? '').toLowerCase().includes(normalizedSearch));
    }, [allFlags, search]);
    const onSelect = useCallback((flag) => {
        if (flag.admin_assignment) {
            toggleFlag.mutate(flag);
            return;
        }
        onClose();
        history.push(`/feature_flags/${flag.id}`);
    }, [history, onClose, toggleFlag]);
    return {
        flags,
        isPending,
        onSelect
    };
}
